/**
 * PageFly Add To Cart integration
 * - Attaches handler to [data-pf-type="ProductATC2"] buttons
 * - Shows loading state
 * - Submits via AJAX to Shopify cart and updates Drawer
 */

(() => {
  function setButtonLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.dataset.originalText = btn.innerText;
      const addingText = btn.getAttribute('data-adding') || 'Adding...';
      btn.classList.add('pf-atc-loading');
      btn.innerText = addingText;
    } else {
      btn.classList.remove('pf-atc-loading');
      btn.removeAttribute('aria-disabled');
      if (btn.dataset.originalText) {
        btn.innerText = btn.dataset.originalText;
      }
    }
  }

  function handleError(btn, message) {
    console.error('[PageFly ATC] Error:', message);
    // Optionally show toast or inline error; for now, revert button text
  }

  function onAtcClick(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    const form = btn.closest('form') || btn.closest('.pf-product-form');
    if (!form) {
      handleError(btn, 'Product form not found');
      return;
    }

    setButtonLoading(btn, true);

    const cartDrawer = document.querySelector('cart-drawer');

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {}, };
    // Ensure correct headers for Shopify section rendering
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // Important: let browser set multipart boundary
    if (config.headers['Content-Type']) delete config.headers['Content-Type'];

    const formData = new FormData(form);

    // Some PageFly buttons may not be type="submit", ensure id present
    if (!formData.get('id')) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) formData.set('id', idInput.value);
    }

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        const sections = cartDrawer.getSectionsToRender().map(s => s.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      } catch (err) {
        console.warn('[PageFly ATC] Failed to append sections', err);
      }
    }

    config.body = formData;

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', config)
      .then(res => {
        // Shopify returns 200 with JSON whether success or error
        return res.json();
      })
      .then(response => {
        if (response && response.status) {
          // Error response
          handleError(btn, response.message || response.description || 'Error adding to cart');
          // Restore button but keep not opening drawer
          return;
        }

        // Publish pubsub event if available
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pagefly-atc', newVariantId: formData.get('id') });
          }
        } catch (e) {}

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Ensure drawer not marked empty
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
        } else {
          // Fallback: go to cart page
          const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location = cartUrl;
        }
      })
      .catch(err => {
        handleError(btn, err?.message || err);
      })
      .finally(() => {
        setButtonLoading(btn, false);
      });
  }

  function init() {
    // Bind ATC click handlers
    const buttons = document.querySelectorAll('[data-pf-type="ProductATC2"]');
    buttons.forEach(btn => {
      if (!btn.dataset.pfAtcBound) {
        btn.addEventListener('click', onAtcClick);
        btn.dataset.pfAtcBound = 'true';
      }
    });

    // Reorder price directly above Quantity + Add To Cart on the PageFly product page.
    // We move the entire price block (.pf-16_) to sit immediately before the qty/ATC block (.pf-27_).
    const root = document.querySelector('.__pf.__pf_8dFv2jqG .pf-14_');

    const movePrice = () => {
      try {
        if (!root) return;
        const price = root.querySelector('.pf-16_'); // ProductPrice2 container
        const qtyAtc = root.querySelector('.pf-27_'); // FlexBlock containing quantity + ATC
        if (price && qtyAtc && price !== qtyAtc.previousElementSibling) {
          root.insertBefore(price, qtyAtc);
        }
      } catch (err) {
        // no-op
      }
    };

    // Initial runs (handle async reflows)
    movePrice();
    setTimeout(movePrice, 0);
    setTimeout(movePrice, 250);
    setTimeout(movePrice, 1000);

    // Observe for child changes inside the column (PageFly/Bold may re-render parts)
    if (root && typeof MutationObserver !== 'undefined') {
      const mo = new MutationObserver(() => movePrice());
      mo.observe(root, { childList: true });
    }

    // Re-run on common events that can reshuffle DOM
    document.addEventListener('variant:change', movePrice);
    document.addEventListener('pagefly:render', movePrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();